export default (fill) => (
  `<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 101 109" enable-background="new 0 0 101 109" xml:space="preserve">
<g id="Стилеобразующие-элементы-услуг">
	<g id="_x37_" transform="translate(-1005.000000, -670.000000)">
		<g id="ugroza" transform="translate(1005.000000, 669.000000)">
			<path fill="${fill? fill : '#E77A2B'}" id="Fill-1"  d="M100,37.2c-0.6-5.6-4.7-12.9-9.2-16.2c0,0-6.7-5-15.1-9.9c-8.4-4.9-15.9-8.3-15.9-8.3
				C57.3,1.6,54,1,50.7,1c-3.3,0-6.7,0.6-9.2,1.7c0,0-7.6,3.4-15.9,8.3c-8.4,4.9-15.1,9.9-15.1,9.9C6,24.3,1.8,31.6,1.3,37.2
				c0,0-0.9,8.4-0.9,18.2c0,9.9,0.9,18.2,0.9,18.2c0.6,5.6,4.7,12.9,9.2,16.2c0,0,6.7,5,15.1,9.9c8.4,4.9,15.9,8.3,15.9,8.3
				c2.5,1.1,5.9,1.7,9.2,1.7c3.3,0,6.7-0.6,9.2-1.7c0,0,7.6-3.4,15.9-8.3c8.4-4.9,15.1-9.9,15.1-9.9c4.5-3.3,8.6-10.6,9.2-16.2
				c0,0,0.9-8.4,0.9-18.2C100.9,45.6,100,37.2,100,37.2L100,37.2z M95.4,73.2c-0.5,4.4-3.9,10.4-7.4,13c-0.1,0-6.6,4.9-14.6,9.6
				c-8,4.7-15.4,8.1-15.5,8.1c-1.8,0.8-4.5,1.3-7.3,1.3c-2.8,0-5.5-0.5-7.3-1.3c-0.1,0-7.4-3.4-15.5-8.1c-8-4.7-14.6-9.6-14.6-9.6
				c-3.5-2.6-6.9-8.7-7.4-13c0-0.1-0.9-8.3-0.9-17.8c0-9.5,0.9-17.7,0.9-17.8c0.5-4.4,3.9-10.4,7.4-13c0.1,0,6.6-4.9,14.6-9.6
				c8-4.7,15.4-8.1,15.5-8.1c1.8-0.8,4.5-1.3,7.3-1.3c2.8,0,5.5,0.5,7.3,1.3c0.1,0,7.4,3.4,15.5,8.1c8,4.7,14.6,9.6,14.6,9.6
				c3.5,2.6,6.9,8.7,7.4,13c0,0.1,0.9,8.3,0.9,17.8C96.3,64.9,95.4,73.1,95.4,73.2L95.4,73.2z"/>
			<path fill="${fill? fill : '#E77A2B'}"  d="M50.7,56.4L50.7,56.4c-0.6,0-1.2-0.3-1.6-0.8c-0.2-0.2-4.6-6.1-4.6-13.4c0-9,3.4-10.9,6.2-10.9
				c2.8,0,6.2,1.9,6.2,10.9c0,7.3-4.4,13.2-4.6,13.4C51.9,56.1,51.3,56.4,50.7,56.4z M50.7,35.3c-1.4,0-2.2,2.6-2.2,6.9
				c0,3.3,1.2,6.4,2.2,8.4c1-2,2.2-5.1,2.2-8.4C52.9,37.8,52,35.3,50.7,35.3z"/>
			<path fill="#ffffff" id="Fill-3"  d="M46.4,65.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2c0,2.3-1.9,4.2-4.2,4.2
				C48.3,69.4,46.4,67.6,46.4,65.2L46.4,65.2z"/>
			<path fill="${fill? fill : '#E77A2B'}"  d="M50.7,71.4c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c3.4,0,6.2,2.8,6.2,6.2S54.1,71.4,50.7,71.4z M50.7,63
				c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C52.9,64,51.9,63,50.7,63z"/>
			<path fill="${fill? fill : '#E77A2B'}"  d="M77,79.4H24.3c-3.5,0-6.5-1.8-8.2-4.9c-1.6-3.1-1.4-6.6,0.5-9.5l26.3-42.5c1.8-2.6,4.6-4.1,7.7-4.1
				c0,0,0,0,0,0c3.1,0,6,1.5,7.7,4.1l26.4,42.6c1.9,2.8,2.1,6.4,0.5,9.4C83.5,77.6,80.4,79.4,77,79.4z M50.7,22.5
				c-1.8,0-3.4,0.8-4.4,2.3L20,67.2c0,0,0,0,0,0.1c-1.1,1.6-1.2,3.7-0.3,5.4c0.9,1.7,2.7,2.8,4.6,2.8H77c2,0,3.7-1,4.6-2.8
				c0.9-1.7,0.8-3.8-0.3-5.4L55,24.7C54,23.3,52.4,22.5,50.7,22.5z M18.3,66.2L18.3,66.2L18.3,66.2z"/>
		</g>
	</g>
</g>
</svg>
`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/uslugas/44.jsx